import { createContext } from "react"
import { defaultYAxisContextValue } from "./defaultYAxisContextValue"
import type { YAxisContextValue } from "./YAxisContextValue"

export const YAxisContext = createContext<YAxisContextValue>(
  defaultYAxisContextValue,
)
